// src/tutoriel/TutorielLanceur.jsx — LES DEUX PORTES D'ENTRÉE.
//
// La BANNIÈRE, proposée au plus trois fois : non bloquante, en haut de
// l'écran. Une modale qui prend l'écran au premier matin suppose que la
// personne est venue apprendre — elle est peut-être venue travailler.
//
// La porte PERMANENTE, elle, est la section « Aide » de la barre latérale
// (AtsSidebar) : un tutoriel qu'on ne peut relancer qu'une fois n'est pas une
// aide, c'est une formalité — et une icône sans nom dans un pied de page ne se
// retrouve pas (vécu 17.09 : « ajoute quand même une section où on peut
// accéder au tuto »).
import React, { useEffect, useMemo, useRef, useState } from 'react';

const BI = ({ icon, style }) => <i className={`bi bi-${icon}`} style={style} />;
const SESSION_CLE = 'erpia.tuto.banniere';

/** La bannière du premier jour. */
export function TutorielBanniere({ tuto }) {
  const [cachee, setCachee] = useState(() => {
    try { return sessionStorage.getItem(SESSION_CLE) === '1'; } catch { return false; }
  });
  const compte = useRef(false);

  // CE QUE LA BANNIÈRE ANNONCE VIENT DU SERVEUR : le parcours du rôle quand il
  // y en a un, tous ceux qu'on peut suivre sinon. C'est aussi la liste de ce
  // qu'elle doit marquer comme vu — l'écran ne la déduit pas. Déduite ici, la
  // deuxième forme n'était comptée nulle part et revenait à chaque chargement.
  const cles = (tuto?.banniereParcours || []).join(',');
  const annonces = useMemo(() => (cles ? cles.split(',') : []), [cles]);
  const noms = annonces.map(c => tuto.parcoursDispo.find(p => p.cle === c)).filter(Boolean);
  const propose = tuto?.propose ? noms.find(p => p.cle === tuto.propose) || null : null;

  // Compter l'affichage UNE fois : c'est ce qui fait taire la bannière au
  // bout de trois fois. Comptée à chaque rendu, elle se tairait tout de suite.
  useEffect(() => {
    if (cachee || compte.current || !annonces.length || !tuto.proposerBanniere) return;
    compte.current = true;
    tuto.banniereVue(annonces);
  }, [cachee, annonces, tuto]);

  if (!tuto?.disponible || cachee || tuto.actif || !noms.length) return null;
  // Une bannière qu'on vient d'afficher ne s'escamote pas sous les yeux : le
  // troisième comptage la ferait disparaître pendant qu'on la lit.
  if (!tuto.proposerBanniere && !compte.current) return null;

  const fermer = () => {
    setCachee(true);
    try { sessionStorage.setItem(SESSION_CLE, '1'); } catch { /* navigation privée */ }
  };

  return (
    <div className="tuto-banniere" role="status">
      <BI icon="question-circle" style={{ flex: 'none' }} />
      <span className="tuto-banniere__texte">
        {propose
          ? `Découvrir ERPIA en dix minutes — un parcours guidé pour les ${propose.pluriel || 'équipes'}.`
          : `Découvrir ERPIA en dix minutes — un parcours guidé par métier : ${noms.map(p => p.pluriel).join(', ')}.`}
      </span>
      {propose ? (
        <button type="button" className="erp-btn erp-btn--primary erp-btn--sm"
          onClick={() => { tuto.ouvrir(propose.cle); fermer(); }}>Commencer</button>
      ) : (
        <button type="button" className="erp-btn erp-btn--primary erp-btn--sm"
          onClick={() => { tuto.basculerPanneau(); fermer(); }}>Choisir</button>
      )}
      <button type="button" className="tuto-banniere__plus-tard" onClick={fermer}>Plus tard</button>
    </div>
  );
}
